import React, { useState } from 'react';

import {
  Dialog,
  DialogContent,
  HStack,
  Heading,
  NewButton,
  Text,
  Textarea,
  VStack,
  useToast,
} from '@eluve/components';
import { templateBuilderStore } from '@eluve/smart-blocks';
import { useDialog } from '@eluve/utility-hooks';

import { GenerateOutputTemplate } from './GenerateOutputTemplate';

export const PrefillTemplateSection: React.FC = () => {
  const toast = useToast();
  const {
    isDialogOpen: isGenerateDialogOpen,
    toggleDialog: toggleGenerateDialog,
    setIsDialogOpen: setIsGenerateDialogOpen,
  } = useDialog();
  const {
    isDialogOpen: isImportDialogOpen,
    toggleDialog: toggleImportDialog,
    setIsDialogOpen: setIsImportDialogOpen,
  } = useDialog();

  const [importedJsonSchema, setImportedJsonSchema] = useState<string>('');

  const updateJsonSchema = () => {
    try {
      const parsedJson = JSON.parse(importedJsonSchema);

      // Validate that it has the expected structure for hydrateArtifact
      if (!parsedJson.artifactTemplate || !parsedJson.outputType) {
        toast.error(
          'Invalid JSON format. Expected exported template structure.',
        );
        return;
      }

      templateBuilderStore.send({
        type: 'hydrateArtifact',
        ...parsedJson,
        isImported: true,
      });

      toast.success('JSON Schema imported successfully');
      setImportedJsonSchema('');
      setIsImportDialogOpen(false);
    } catch {
      toast.error('Invalid JSON format. Please check your input.');
    }
  };

  return (
    <HStack gap={5}>
      <Text size="md" className="text-nowrap">
        Pre-fill your template
      </Text>
      <HStack gap={2}>
        <NewButton
          type="outline"
          icon={{ name: 'FileInput' }}
          text="Import JSON"
          size="s"
          onClick={toggleImportDialog}
        />
        <NewButton
          type="outline"
          icon={{ name: 'Wand' }}
          text="Generate Template with AI"
          size="s"
          onClick={toggleGenerateDialog}
        />

        {/* Import JSON Dialog */}
        <Dialog open={isImportDialogOpen} onOpenChange={setIsImportDialogOpen}>
          <DialogContent className="max-w-xl">
            <VStack gap={4}>
              <Heading size="lg">Import JSON</Heading>
              <Textarea
                value={importedJsonSchema}
                onChange={(e) => setImportedJsonSchema(e.target.value)}
                className="mb-4 h-64 w-full font-mono"
                placeholder="Paste exported JSON here"
              />
              <NewButton
                onClick={updateJsonSchema}
                icon={{ name: 'FileInput' }}
                text="Import"
              />
            </VStack>
          </DialogContent>
        </Dialog>

        {/* Generate Template Dialog */}
        <Dialog
          open={isGenerateDialogOpen}
          onOpenChange={setIsGenerateDialogOpen}
        >
          <DialogContent className="max-w-xl">
            <GenerateOutputTemplate
              onTemplateGenerated={() => setIsGenerateDialogOpen(false)}
            />
          </DialogContent>
        </Dialog>
      </HStack>
    </HStack>
  );
};
